/**
 * global.js
 *
 * 网易号相关变量
 * @Author: jruif
 * @Date: 2017/9/13 下午6:25
 */
import {
  isObject
} from '../util/isType';
import extend from 'deep-extend';
const variables = {
  star: [{
    label: '移除',
    value: -1
  },
  {
    label: '预备',
    value: 0
  },
  {
    label: '一星',
    value: 1
  },
  {
    label: '二星',
    value: 2
  },
  {
    label: '三星',
    value: 3
  },
  {
    label: '四星',
    value: 4
  },
  {
    label: '五星',
    value: 5
  },
  ],
  accountLevelType: [{
    label: '未审核',
    value: 0
  },
  {
    label: '差',
    value: 1
  },
  {
    label: '中等',
    value: 2
  },
  {
    label: '优质',
    value: 3
  },
  {
    label: '质量次优',
    value: 4
  },
  {
    label: '待定',
    value: 5
  },
  {
    label: '特色头部',
    value: 6
  },
  {
    label: '普通次优',
    value: 7
  },
  {
    label: '流量次优',
    value: 8
  },
  ],
  authority: [{
    label: '内容运营中心',
    value: 0
  },
  {
    label: '本地事业部',
    value: 1
  },
  {
    label: '政务中心',
    value: 2
  },
  {
    label: '直播中心',
    value: 3
  },
  {
    label: '',
    value: 4
  },
  {
    label: '企业号运营',
    value: 5
  },
  ],
  contentTypes: [{
    value: 0,
    label: '全部类型',
    _alias: 'all'
  },
  {
    value: 4,
    label: '全部类型',
    _alias: 'article&gallery'
  },
  {
    value: 1,
    label: '文章',
    _alias: 'article'
  },
  {
    value: 3,
    label: '图集',
    _alias: 'gallery'
  },
  {
    value: 2,
    label: '视频',
    _alias: 'video'
  },
  ],
  contentStateTypes: [{
    value: -1,
    label: '全部状态',
    _alias: 'all'
  },
  {
    value: 0,
    label: '草稿'
  },
  {
    value: 2,
    label: '未通过'
  },
  {
    value: 3,
    label: '已发布'
  },
  {
    value: 5,
    label: '处理失败'
  },
  {
    value: 6,
    label: '管理员下线'
  },
  {
    value: 7,
    label: '作者下线'
  },
  {
    value: 8,
    label: '待发布'
  },
    // {
    //   value: 10,
    //   label: '作者删除'
    // },
    // {
    //   value: 11,
    //   label: 'mcn下线',
    //   _alias: 'mcnDownLine'
    // },
  ],
  authStates: [{
    value: 0,
    label: '未申请'
  },
  {
    value: 1,
    label: '审核中'
  },
  {
    value: 2,
    label: '已认证'
  },
  {
    value: 3,
    label: '已拒绝'
  },
  {
    value: 4,
    label: '已取消'
  },
  ],
  authTypes: [{
    value: 1,
    label: '原创认证'
  },
  {
    value: 2,
    label: '身份认证'
  },
  {
    value: 3,
    label: '兴趣认证'
  },
  {
    value: 4,
    label: '机构认证'
  },
  {
    value: 5,
    label: '特色认证'
  },
  {
    value: 11,
    label: '黄v认证'
  },
  {
    value: 12,
    label: '蓝v认证'
  },
  ],
  //mcn 合同状态
  contractStates: [{
    value: -1,
    label: '全部邀请状态',
  },
  {
    value: 0,
    label: '邀请待确认',
  },
  {
    value: 1,
    label: '邀请成功',
  },
  {
    value: 2,
    label: '运营待确认',
  },
  {
    value: 3,
    label: '子账号拒绝',
  },
  {
    value: 4,
    label: '已拒绝',
  },
  {
    value: 5,
    label: '子帐号已授权',
  },
  {
    value: 6,
    label: '待子帐号授权',
  },
  ],
  cooperateType: [{
    label: '全部',
    value: ''
  },
  {
    value: 0,
    label: '内容生产提供方',
  },
  {
    value: 1,
    label: '第三方内容平台',
  },
  ],
  auditState: [{
    value: 0,
    label: '审核中',
  },
  {
    value: 1,
    label: '通过',
  },
  {
    value: 2,
    label: '拒绝',
  },
  ],
  statusOptions: [{
    label: '全部状态',
    value: ''
  },
  {
    label: '使用中',
    value: 1
  },
  {
    label: '已废弃',
    value: 0
  },
  {
    label: '已删除',
    value: -1
  },
  ],
  yjRightState: [{
    label: '待维权',
    value: 0
  },
  {
    label: '维权失败',
    value: 1
  },
  {
    label: '维权成功',
    value: 2
  },
  {
    label: '维权中',
    value: 3
  },
  {
    label: '不维权',
    value: 4
  }],
  // (账号类型)
  accountType: [{
    label: '媒体',
    value: 0
  },
  {
    label: '自媒体',
    value: 1
  },
  {
    label: '组织机构',
    value: 2
  },
  {
    label: '直播号',
    value: 3
  },
  {
    label: '企业',
    value: 4
  }],
};

const global = {
  getLabelByValue: (name, value) => {
    const target = global[name].find(item => item.value === Number(value));
    return target ? target.label : '';
  },
};

Object.keys(variables).forEach(key => {
  Object.defineProperty(global, key, {
    get: function () {
      if (Array.isArray(variables[key])) {
        // todo: 可能会有其他类型，先假设为object
        return [...variables[key]].map(item => extend({}, item));
      } else if (isObject(variables[key])) {
        return extend({}, variables[key]);
      }
      return variables[key];
    },
  });
});

export default global;
